module.exports = {
	"name": "appxigon-react",
	"version": "0.0.82",
	"description": "Appxigon implementation on React JS",
	"scripts": {
		"build:readme": "toctoc README.md -w",
		"build:lib": "rimraf lib && cross-env NODE_ENV=production babel -d lib/ src/",
		"build:dist": "rimraf dist && cross-env NODE_ENV=production webpack --config webpack.config.dist.js --optimize-minimize",
		"build:playground": "rimraf build && cross-env NODE_ENV=production webpack --config webpack.config.prod.js --optimize-minimize && cp playground/index.prod.html build/index.html",
		"dist": "npm run build:lib && npm run build:dist",
		"lint": "eslint src test playground",
		"publish-to-gh-pages": "npm run build:playground && gh-pages --dist build/",
		"publish-npmjs": "npm run dist && npm publish",
		"start": "node devServer.js",
		"tdd": "cross-env NODE_ENV=test  mocha --compilers js:babel-register --watch --require ./test/setup-jsdom.js test/**/*_test.js",
		"test": " cross-env NODE_ENV=test   mocha --compilers js:babel-register --require ./test/setup-jsdom.js test/**/*_test.js",
		"update-locales": "i18n-gen -f json -p ./playground/i18n -s 'https://docs.google.com/spreadsheets/d/1AOogDryIc_NUZUjbvGfMeoK5g_-gM55g_bD4GZGLWnw/pub?gid=0&single=true&output=tsv'"
	},
	"main": "lib/index.js",
	"files": [
		"dist",
		"lib"
	],
	"engineStrict": false,
	"engines": {
		"npm": "^2.14.7",
		"node": ">=6"
	},
	"peerDependencies": {
		"react": "^15.0.0"
	},
	"dependencies": {
		"appxigon-common": "~0.0.18",
		"co": "^4.6.0",
		"json-loader": "^0.5.4",
		"jsonschema": "^1.0.2",
		"lodash.topath": "^4.5.2",
		"moment": "^2.18.1",
		"node-fetch": "^1.6.3",
		"prelude-ls": "^1.1.2",
		"react-bootstrap": "^0.30.8",
		"react-dropzone": "^3.11.0",
		"react-event-listener": "^0.4.5",
		"react-redux": "^5.0.3",
		"react-router": "^3.0.2",
		"react-router-redux": "^4.0.8",
		"redux": "^3.6.0",
		"redux-logger": "^3.0.1",
		"redux-thunk": "^2.2.0",
		"setimmediate": "^1.0.5",
		"superagent": "^3.5.0",
		"traverse": "^0.6.6",
		"yaml-loader": "^0.4.0"
	},
	"devDependencies": {
		"lsx-pug": "^0.1.45",
		"atob": "^2.0.3",
		"babel-cli": "^6.18.0",
		"babel-core": "^6.18.2",
		"babel-eslint": "^6.1.2",
		"babel-loader": "^6.2.7",
		"babel-plugin-add-module-exports": "^0.2.1",
		"babel-plugin-react-transform": "^2.0.2",
		"babel-plugin-transform-class-properties": "^6.18.0",
		"babel-plugin-transform-decorators-legacy": "^1.3.4",
		"babel-plugin-transform-es3-member-expression-literals": "^6.22.0",
		"babel-plugin-transform-es3-property-literals": "^6.22.0",
		"babel-plugin-transform-object-rest-spread": "^6.16.0",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-polyfill": "^6.23.0",
		"babel-preset-es2015": "^6.18.0",
		"babel-preset-es2015-loose": "^8.0.0",
		"babel-preset-react": "^6.16.0",
		"babel-preset-stage-0": "^6.22.0",
		"babel-register": "^6.18.0",
		"babel-runtime": "^6.23.0",
		"chai": "^3.3.0",
		"codemirror": "^5.20.2",
		"cross-env": "^2.0.1",
		"css-loader": "^0.23.1",
		"eslint": "^3.15.0",
		"eslint-plugin-react": "^4.2.3",
		"estraverse": "^4.2.0",
		"estraverse-fb": "^1.3.1",
		"express": "^4.14.0",
		"extract-text-webpack-plugin": "^1.0.1",
		"file-loader": "^0.10.1",
		"gh-pages": "^0.11.0",
		"highcharts": "^5.0.9",
		"html": "0.0.10",
		"i18n-gen": "^0.5.1",
		"jsdom": "^8.3.0",
		"livescript": "^1.5.0",
		"livescript-loader": "^0.1.5",
		"mocha": "^2.5.3",
		"react": "^15.0.0",
		"react-addons-test-utils": "^15.3.2",
		"react-codemirror": "^0.2.3",
		"react-dom": "^15.3.2",
		"react-highcharts": "^11.5.0",
		"react-svg-loader": "^1.1.1",
		"react-transform-catch-errors": "^1.0.0",
		"react-transform-hmr": "^1.0.1",
		"redbox-react": "^1.3.3",
		"rimraf": "^2.5.4",
		"sinon": "^1.17.6",
		"style-loader": "^0.13.1",
		"toctoc": "^0.2.3",
		"webpack": "^1.13.3",
		"webpack-core": "^0.6.9",
		"webpack-dev-middleware": "^1.8.4",
		"webpack-hot-middleware": "^2.13.2",
		"yaml-loader": "^0.4.0"
	},
	"directories": {
		"test": "test"
	},
	"repository": {
		"type": "git",
		"url": ""
	},
	"author": "Roger LAM <rlhk.open@gmail.com>",
	"keywords": [
		"appxigon",
		"appxigon-react",
		"react",
		"form",
		"json-schema",
		"yaml-schema"
	],
	"license": "Apache-2.0",
	"homepage": ""
};


//////////////////
// WEBPACK FOOTER
// ../package.json
// module id = 585
// module chunks = 0